import React, { FunctionComponent } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import StyledContainer from '../../../shared/components/styled-container/styled-container';
import StyledTypography from '../../../shared/components/styled-typography/styled-typography';
import { useOnFeatureClearingStates } from '../../../shared/hooks/use-on-feature-clearing-states/use-on-feature-clearing-states.hook';
import { useRouteRedirect } from '../../../shared/hooks/use-route-redirect/use-route-redirect.hook';
import SnackBarContextProvider from '../../shared/components/snack-bar-context/SnackBarContext';
import { resetGame } from '../store/slices/web-game.slice';

const WebGamesPageLayout: FunctionComponent = (): JSX.Element => {
  useRouteRedirect('/game-center-management', 'games');

  const location = useLocation();
  const isOnCreate = location.pathname.startsWith(
    '/game-center-management/create'
  );

  const isOnGamesPage = location.pathname.startsWith(
    '/game-center-management/games'
  );

  useOnFeatureClearingStates([resetGame()]);

  return (
    <SnackBarContextProvider>
      <StyledContainer maxWidth={false}>
        <StyledTypography>
          {isOnGamesPage ? 'Games' : isOnCreate ? 'Add New Game' : 'Edit Game'}
        </StyledTypography>
        <Outlet />
      </StyledContainer>
    </SnackBarContextProvider>
  );
};

export default WebGamesPageLayout;
